<template>
  <div class="app-container">
    <component
      :is="currentCom"
      :key="currentCom"
      :progress="progress"
      @change-com="handleChangeCom"
      @share="handleShare"
    />

    <div class="modal" v-if="isShowModal" @click="hideModal">
      <loading
        v-if="isLoading"
        class="loading-wrap"
        :borderColor="borderColor"
      />

      <div v-else :class="isLeft ? 'left-wrap' : 'right-wrap'">
        <img :src="isLeft ? imgLeftSrc : imgRightSrc" class="tips-icon" />
        <div class="tips-txt">
          <p>请点击{{ isLeft ? '左' : '右' }}上角</p>
          <p>将它分享给指定朋友</p>
          <p>或分享到朋友圈</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Index from '../components/Index'
import Vr from '../components/Vr'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    Index,
    Vr,
  },

  computed: mapState(['currentCom', 'isShowModal', 'isLoading']),

  data() {
    return {
      progress: 100,
      imgLeftSrc: require('@/assets/images/common/left-tip.png'),
      imgRightSrc: require('@/assets/images/common/right-tip.png'),
      isLeft: true,
      borderColor: '#fff'
    }
  },

  mounted() {
    this.setIsShowModal(false)
    const that = this
    window.onresize = function () {
      that.setTipIncon()
    }
  },

  methods: {
    ...mapMutations(['setCurrentCom', 'setPhoneScreenType', 'setIsShowModal']),

    handleChangeCom(component = 'index') {
      this.setCurrentCom(component)
    },

    // 分享操作
    handleShare() {
      // this.showModal = true
      this.setTipIncon()
    },

    // 分享提示
    setTipIncon() {
      const clientWidth = document.documentElement.clientWidth
      const clientHeight = document.documentElement.clientHeight
      if (clientWidth > clientHeight) {
        // 当前手机处于横屏状态
        this.isLeft = false
        // this.setPhoneScreenType(false)
      } else {
        // 当前手机处于竖屏状态
        this.isLeft = true
        // this.setPhoneScreenType(true)
      }
    },

    hideModal() {
      // this.showModal = false
      if (!this.isLoading) {
        this.setIsShowModal(false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1000;
  transform: translateZ(1px);
  .loading-wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .left-wrap {
    position: absolute;
    left: 100px;
    top: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .right-wrap {
    position: absolute;
    right: 100px;
    top: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .tips-icon {
    width: 140px;
    height: 162px;
  }
  .tips-txt {
    font-family: KaiTi;
    font-weight: 400;
    color: #fff;
    font-size: 32px;
    line-height: 48px;
    text-align: center;
  }
}

.app-container {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  overflow: hidden;
}
</style>
